import { render } from "./AssetList.vue?vue&type=template&id=c24076f4&scoped=true"
import script from "./AssetList.vue?vue&type=script&lang=js"
export * from "./AssetList.vue?vue&type=script&lang=js"

import "./AssetList.vue?vue&type=style&index=0&id=c24076f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24076f4"]])

export default __exports__